const binding = { modules: {}, dataActions: {} };

    (binding.modules['defa-info-tile'] = {
        c: () => require('partner/modules/defa-info-tile/defa-info-tile.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'defa-info-tile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/defa-info-tile'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|defa-info-tile|defa-info-tile'] = {
                c: () => require('partner/modules/defa-info-tile/defa-info-tile.view.tsx'),
                cn: '__local__-__local__-defa-info-tile'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };